// 若使用 IM 能力则引入
import NIM from 'nim-web-sdk-ng'
//  IM 功能 浏览器
import NIMSDK from 'nim-web-sdk-ng/dist/NIM_BROWSER_SDK'
// 若使用聊天室能力则引入
import ChatroomSDK from 'nim-web-sdk-ng/dist/CHATROOM_BROWSER_SDK'
import {
  registerIM,
  chatRoomAddress
} from '@/api/wyapi.js'
import {
  Chatroom
} from '@yxim/nim-web-sdk'
let appkey =
'0bfe8e9f7530e5e8a4ce31cd96b48375'; //  生产 1455eac28ddf0b89284455d704af7532   测试 0bfe8e9f7530e5e8a4ce31cd96b48375

export default appkey

let LZNIM = null;
// 初始化登录
export async function initNIM(user, islogin) {
  let query = {};
  if (islogin) {
    query = {
      "appkey": appkey, //  生产 1455eac28ddf0b89284455d704af7532   测试 0bfe8e9f7530e5e8a4ce31cd96b48375
      account: user.accid ? user.accid : '',
      token: user.imToken ? user.imToken : '', //
      debugLevel: 'debug', // 日志级别
    }
  } else {
    query = {
      "appkey": appkey, //  生产 1455eac28ddf0b89284455d704af7532   测试 0bfe8e9f7530e5e8a4ce31cd96b48375
      debugLevel: 'debug', // 日志级别
    }
  }
  const nim = new NIM(query);
  const eventList = [
    'logined',

    'multiPortLogin',

    'kicked',

    'willReconnect',

    'disconnect', // 链接断开

    'msg',

    'syncdone',

    'proxyMsg', 'syncRoamingMsgs', 'syncOfflineMsgs',
    'syncMyNameCard', 'syncdone', 'sessions', 'updateMyNameCard', 'updateBlackList', 'update      MuteList',
    'sysMsg', 'syncSysMsgs', 'syncFriend',
    'friends', // 好友相关资料同步
    'users', 'updateSystemMessages', 'sysMsgUnread', 'pushEvents',
    'teamMsgReceipts', 'updateSession',

    'teams',
    'createTeam', // 收到了多端同步创建群的情况
    'updateTeamMember',
    'updateTeam', 'addTeamMembers', 'updateTeamManagers', 'transferTeam', 'removeTeamMembers',
    'dismissTeam', // 出发了解散群
    'updateTeamMembersMute',
  ]

  // 循环监听各个事件
  eventList.forEach((key) => {
    nim.on(key, (res) => {
      if (key == 'logined') {
        console.log('初始化成功登陆');
      } else {
        console.log(`网易云信事件 ${key} event：`, res ? JSON.parse(JSON.stringify(res)) : res);
      }
    });
  })
  await nim.connect();
  LZNIM = nim
  return nim
}

async function noLoginInitRoom(rooomid) {
  let result = await chatRoomAddress({
    roomId: rooomid
  });
  if (result.data.code == 200) {
    let {
      addressList,
      roomId
    } = result.data.data;
    console.log('聊天室地址', addressList);
    console.log('昵称登录', rooomid, addressList);
    var chatroom = Chatroom.getInstance({
      "appKey": '1455eac28ddf0b89284455d704af7532', //  生产 1455eac28ddf0b89284455d704af7532   测试 0bfe8e9f7530e5e8a4ce31cd96b48375
      "chatroomId": rooomid,
      "chatroomAddresses": addressList,
      "chatroomNick": 'Visitor',
      "chatroomAvatar": 'https://oss.ansongqiubo.com/assets/touxiang2.png',
      "isAnonymous": true,
      "onconnect": onChatroomConnect,
      "onerror": onChatroomError,
      "onmsgs": onChatroomMsgs
    });

    function onChatroomConnect(obj) {
      // 该处chatroom为全局生成的实例
      console.log('成功吧', chatroom);
    }

    function onChatroomError(error, obj) {
      console.log('发生错误', error, obj);
    }

    function onChatroomMsgs(msgs) {
      console.log('收到聊天室消息', msgs);
    }
    return chatroom
  }
}

// 初始化聊天群
async function initRoom(user, chatroomAddresses, rooomid, islogin = false) {
  console.log(user, chatroomAddresses);
  let loginParams = {
    "appkey": appkey, // 1455eac28ddf0b89284455d704af7532
    "token": user.imToken,
    "account": user.accid,
    "isAnonymous": false,
    "chatroomId": rooomid,
    "chatroomAddresses": [...chatroomAddresses]
  }
  const chatroom = new ChatroomSDK(
    loginParams
  );
  await chatroom.connect();
  return chatroom
}

export async function initNIMApi(rooomid, cb) {

    if(!rooomid){
      console.error('未检测到房间号');
      return false
    }
    let userinfo = {}
    if(localStorage.getItem('token')){
    let StorageIM =  localStorage.getItem('wyuserinfo');
    if(StorageIM && StorageIM.length >0){
      userinfo = JSON.parse(StorageIM);
      if(!userinfo.imToken){
        console.log('用户缓存数据不对');
        let userdata =  await registerIM();
        userinfo = userdata.data.data;
      }
    }else{
      let userdata =  await registerIM();
      userinfo = userdata.data.data;
    }
    console.log('StorageIM',JSON.parse(StorageIM));
    if(userinfo.imToken){
    // 缓存注册
      localStorage.setItem('wyuserinfo',JSON.stringify(userinfo));
      cb(1)
      if(!LZNIM){
        console.log('需要重新初始化',userinfo,rooomid);
        LZNIM = await initNIM(userinfo,true);
      }
      console.log('房间号',rooomid);
      // 获取地址
      let roominfo =  await LZNIM.plugin.getChatroomAddress({ chatroomId: rooomid });
      console.log('聊天室地址',roominfo);
      // 初始化聊天室
      cb(2)
     return initRoom(userinfo,roominfo,rooomid,true)
    }
  }else{

   }
}



// WEBPACK FOOTER //
// ./src/js_sdk/wysocket.js